import React from 'react';
import CustomIcon from '../Common/CustomIcon/CustomIcon';

import style from './CustomModal.module.css';

import {
	buildTestData,
} from 'Vulture/TestData';

// Some modals (Buildings) write immediately and never stage into the page-wide
// pendingChanges bag, so emptying it would discard edits staged elsewhere on the page.
// app.closeModal() empties it; this is the exit those modals take instead.
//
// The predicate is shared with the close itself so the two cannot diverge: skipping the
// confirmation on keepPendingChanges alone, while the close still falls back to
// app.closeModal() when the handler is missing, would empty the bag with nothing asked.
export const willPreservePendingChanges = (app, modalProps) =>
	Boolean(modalProps.keepPendingChanges) && typeof app.closeModalAndKeepPendingChanges === 'function';

export const closeModalPreservingOptIn = (app, modalProps) => {
	if (willPreservePendingChanges(app, modalProps)) {
		app.closeModalAndKeepPendingChanges();

		return;
	}

	app.closeModal();
};

class ModalView extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			// modalOpen: this.props.modalOpen,
			// canOpen: this.props.canOpen
			confirmModal:        false,
			confirmModalContent: '',
		};
	}

	closeModal() {
		closeModalPreservingOptIn(this.props.app, this.props.modalProps);
	}

	render() {
		let {
			modalProps,
			modalSize,
		} = this.props;

		switch (modalSize || (modalProps || {}).modalSize) {
		case 1:
			modalSize = 'small';
			break;
		case 2:
			modalSize = 'medium';
			break;
		case 3:
			modalSize = 'large';
			break;
		case 4:
			modalSize = 'custom';
			break;
		case 5:
			modalSize = 'flexible';
			break;
		case 6:
			modalSize = 'mobile_preview';
			break;
		default:
			modalSize = 'large';
		}
		let modalBody = React.cloneElement(modalProps.jsx, {
			...modalProps,
			...this.props,
		}, modalProps.jsx.props.children);

		let closeButton = true;
		if (modalProps && modalProps.omitClose) {
			closeButton = false;
		}

		let confirmModal = '';
		if (this.state.confirmModal === true) {
			confirmModal =
			<div className="confirm-modal-container">
				<div className="confirm-modal-content">
					{this.state.confirmModalContent}
				</div>
			</div>;
		}

		return (
			<React.Fragment>
				<div className={`${style.modalWrapper}`}>
					<div id="modal" className={`${style.modal} ${style[`${modalSize}`]}`}>
						{/* <div className={style.modal}> */}
						<div className={style.modalContainer}>
							<div className={style.modalHeader}>
								<div className={style.modalTitle} data-test-id='customModalTitle'>{modalProps.title}</div>
								{closeButton ?
									<div className={style.modalClose}
										data-test-id="modalClose"
										data-testing-info={buildTestData('button--close')}
										onClick={(e) => {
											e.preventDefault();
											const hasUnsavedElsewhere = modalProps.pendingChanges || window.form.hasNewVals();
											
											// An opted-in modal stages into neither page-wide store, so closing it discards
											// nothing of its own. Asking to confirm would be asking about another area's
											// unsaved work, which this exit does not touch.
											if (!willPreservePendingChanges(this.props.app, modalProps) && hasUnsavedElsewhere) {
												this.setState({
													confirmModal:        true,
													confirmModalContent:
														<>
															<p>By cancelling you will lose your unsaved changes. Are you sure you want to continue?</p>
															<div className="confirm-modal-buttons">
																<button className="button-outlined" onClick={(e) => {
																	this.setState({
																		confirmModal: false,
																	});

																	// Only a modal that has not opted in can raise this dialog, and for
																	// those the warning is accurate: Yes discards the staged field values.
																	window.form.newVals = {};

																	this.closeModal();
																}}>Yes</button>
																<button className="button" onClick={(e) => {
																	this.setState({
																		confirmModal: false,
																	});
																}}>No</button>
															</div>
														</>,
												});
											} else {
												this.setState({
													heightOfModal: 0,
												});
											
												this.closeModal();
											
												// Only when nothing was staged anywhere. An opted-in modal closing over
												// another area's unsaved work used to take the confirm branch, whose exit
												// never touched the library modal — force-closing it here would drop a
												// media-library modal open alongside this one.
												if (!hasUnsavedElsewhere) {
													this.props.app.closeLibraryModal();
												}
											}
										}}>
										<CustomIcon icon='times' />
									</div> :
									null
								}
							</div>
							<div className={`${style.modalContent} ${modalProps.customClass || ''}`}>
								{confirmModal}
								{modalBody}
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default ModalView;